"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyFail = exports.right = exports.left = exports.Right = exports.Left = exports.Res = void 0;
const lodash_1 = require("lodash");
class Res {
    constructor(isSuccess, error, value) {
        if (isSuccess && error) {
            throw new Error("InvalidOperation: A result cannot be successful and contain an error");
        }
        if (!isSuccess && !error) {
            throw new Error("InvalidOperation: A failing result needs to contain an error msg");
        }
        this.isOk = isSuccess;
        this.isFail = !isSuccess;
        this.error = error;
        this._value = value;
        Object.freeze(this);
    }
    getValue() {
        if (!this.isOk) {
            console.log(this.error);
            throw new Error("Can't get the V of an error result. Use 'errorValue' instead.");
        }
        return this._value;
    }
    exists() {
        if (this.isFail)
            return false;
        if (this._value && lodash_1.isFunction(this._value.exists()))
            return this._value.exists();
        return false;
    }
    val() {
        if (!this.isOk) {
            console.log(this.error);
            throw new Error("Can't get the V of an error result. Use 'errorValue' instead.");
        }
        if (this._value && lodash_1.isFunction(this._value.val))
            return this._value.val();
        throw new Error("Not snapshot. Cannot call val()");
    }
    errMsg() {
        if (lodash_1.isString(this.error))
            return this.error;
        if (lodash_1.isObject(this.error))
            return (this.error && this.error.message) || null;
        return null;
    }
    errorValue() {
        return this.error;
    }
    static ok(value) {
        return new Res(true, null, value);
    }
    static fail(error) {
        return new Res(false, error);
    }
    static combine(results) {
        for (const result of results) {
            if (result.isFail)
                return result;
        }
        return Res.ok();
    }
    logAndThrowOnError() {
        if (this.isFail) {
            console.dir(this.error);
            throw new Error(this.errMsg());
        }
    }
}
exports.Res = Res;
class Left {
    constructor(value) {
        this.value = value;
    }
    isLeft() {
        return true;
    }
    isRight() {
        return false;
    }
}
exports.Left = Left;
class Right {
    constructor(value) {
        this.value = value;
    }
    isLeft() {
        return false;
    }
    isRight() {
        return true;
    }
}
exports.Right = Right;
exports.left = (l) => {
    return new Left(l);
};
exports.right = (a) => {
    return new Right(a);
};
function anyFail(...results) {
    return results.filter((item) => item.isFail).length > 0;
}
exports.anyFail = anyFail;
//# sourceMappingURL=Res.js.map